import { Component, ElementRef, Renderer2, ViewChild, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpEventType, HttpEvent } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ToastrService } from 'ngx-toastr';
import { adminBotUpsideHanumanSocket } from 'src/app/app.module';
import { getDisplayedPages } from 'src/app/lib/pagination';
import { firstCapital } from 'src/app/lib/capital';
import { dateHours, dateHoursClose, dateHourswithTime, dateTimeFormat } from 'src/app/lib/dateFilter';
import isEmpty from 'src/app/lib/isEmpty';
import { toFixed, toFixedDown, truncateDecimals } from 'src/app/lib/roundOf';
import { adminHanumanUpsideService } from 'src/app/services/bot.adminHanumanUpSIde.service';
import { ExportService } from 'src/app/services/export-service.service';
import { AuthFacade } from 'src/app/store/auth';
import { PairFacade } from 'src/app/store/pair';
import { PositionDetailsFacade } from 'src/app/store/positionDetails';
import { TradePairFacade } from 'src/app/store/tradepair';

@Component({
  selector: 'app-adminBotUpsideHanumanOrderHistory',
  templateUrl: './adminBotorderhistory.component.html',
  styleUrls: ['./adminBotorderhistory.component.css']
})
export class adminBotUpsideHanumanOrderHistoryComponent {
  @ViewChild('firstTab') firstTab!: ElementRef;
  @Output() botSelected = new EventEmitter<any>();
  onWheel(event: WheelEvent) {
    event.preventDefault(); // Prevents the default scroll behavior
  }

  toFixedDown = toFixedDown
  toFixed = toFixed
  parseFloat = parseFloat
  isEmpty = isEmpty
  dateTimeFormat = dateTimeFormat
  firstCapital = firstCapital
  truncateDecimals = truncateDecimals
  pairData: any = {}
  pairs: any = []
  sumProfit: any = { sumpnl: 0, sumpnlval: 0 }
  totCurrent: any = 0
  activeBotData: any = []
  activeBotCount: any = 0
  botHistory: any = []
  orderList: any = {}
  openOrderList: any = {}
  botPositionHistory: any = {}
  cancelLoader: any = false
  openModelBotDetails: any = {}
  botProfit: any = {}
  sumProfitHis: any = {
    sumpnl: 0,
    sumpnlval: 0,
    curVal: 0,
    inv: 0,
    pnlVal: 0,
  }
  auth: any = {}
  isPos: any = {}
  isPosition: any = false;
  searchForm: FormGroup;
  selectedTab: any = "openPosition";
  selectedOrderTab: any = "positionHistory";
  thisPairBot: any = {}
  environment = environment;
  originalHistory: any[] = []; // Your original data from API
  filter: any = {
    page: 1,
    limit: 10,
    totalPages: 0,
    pairName: "all",
    orderType: "all",
    buyorsell: "all",
    status: "all"
  }
  orderFilter: any = {
    page: 1,
    limit: 50,
    totalPages: 0,
    pairName: "all",
    orderType: "all",
    buyorsell: "all",
    status: ""
  }
  getDisplayedPages: number[] = []
  getDisplayedOrderPages: number[] = []
  displayedColumns = {
    label: [
      'Pair/Bot Type',
      'Current Value',
      'PNL',
      'PNL In USDT',
      'TXNS/Time',
      'Investment',
      'orderValue'
    ],
    cols: [
      'pairName',
      'currentvalue',
      'pl',
      'pnlval',
      'createdAt',
      'investment',
      'orderValue'
    ]
  };
  formValue: any = {
    investment: 100,
    upperPrice: 0,
    lowerPrice: 0,
    grids: 5,
    isGridStepPercent: true,
    gridStepPercent: 0,
    gridStepValue: 25,
    orders: [],
    profitType: 'arithmetic',
    autoAdd: false,
    takeprofitRatio: 2,
    takeprofitCallback: 0,
    stopLoss: 1,
    isstoploss: false,
    total: [''],
    totalBots: 0,
    firstOrderInvest: 0,
    secondOrderInvest: 0,
    thirdOrderInvest: 0,
    profitPercentage: 0.1
  }
  isSubmitting = false;
  isDownloading = false;
  downloadProgress = 0
  serverErrors: any = {}
  inputFields: any = []
  loader = false

  constructor(
    private service: adminHanumanUpsideService,
    private toastr: ToastrService,
    private botFacade: TradePairFacade,
    private pairFacade: PairFacade,
    private positionDetails: PositionDetailsFacade,
    private botSocket: adminBotUpsideHanumanSocket,
    private authFacade: AuthFacade,
    private renderer: Renderer2,
    private exportService: ExportService,
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
  ) {
    this.authFacade.auth$.subscribe({
      next: (userAuth: any) => {
        this.auth = userAuth
      },
      error: (err: any) => { }
    });
    this.searchForm = this.fb.group({
      fromDate: [''],
      toDate: ['']
    });
  }

  selectBot(bot: any) {
    bot.isBot = true
    if (bot.postRound) bot.isBot = false
    this.botSelected.emit(bot);
  }

  ngOnInit() {
    this.getSinglePair();
    this.getPairs();
  }

  resetFilter(): void {
    this.searchForm.reset();
    this.getSinglePair();
    this.getPairs();
  }

  routeToDownload() {
    this.router.navigate(['/history/order']);
  }

  onSearch(): void {
    const { fromDate, toDate } = this.searchForm.value;
    const from = fromDate ? new Date(fromDate) : null;
    const to = toDate ? new Date(toDate) : null;
    this.botHistory = this.botHistory.filter((item: { createdAt: string | number | Date }) => {
      const createdAt = new Date(item.createdAt);
      if (from && to) {
        return createdAt >= from && createdAt <= to;
      } else if (from) {
        return createdAt >= from;
      } else if (to) {
        return createdAt <= to;
      }
      return true;
    });
  }

  downloadExcel(botId: any) {
    this.isDownloading = true;
    this.downloadProgress = 0;

    this.service.download({ botId }).subscribe({
      next: (event: any) => {
        if (event.type === HttpEventType.DownloadProgress) {
          // event.loaded and event.total (if server provides Content-Length)
          if (event.total) {
            this.downloadProgress = Math.round(100 * event.loaded / event.total);
          }
        } else if (event.type === HttpEventType.Response) {
          if (event.body) {
            const blob = event.body as Blob;
            const a = document.createElement('a');
            const objectUrl = URL.createObjectURL(blob);

            a.href = objectUrl;
            a.download = 'history.csv';

            // FIX: Append to body, click, then remove
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);

            URL.revokeObjectURL(objectUrl);
            this.isDownloading = false;
          }
        }
      },
      error: (err) => {
        console.error(err);
        this.isDownloading = false;
      }
    });
  }



  getPairs() {
    this.pairFacade.pair$.subscribe({
      next: (pairs: any) => {
        this.pairs = pairs
        this.isPosition = false
        this.getActiveBot()
        this.getBotProfit()
        this.botSocket.on('botHistory', this.getBotHistory.bind(this))
        this.botSocket.on('botHistory', this.getActiveBot.bind(this))
        this.botSocket.on('botHistory', this.getBotProfit.bind(this))

        this.route.paramMap.subscribe(params => {
          let tikerRoot = params.get('tikerRoot');
          let findPair = pairs.filter((pair: any) => `${pair?.firstCurrencySymbol}_${pair?.secondCurrencySymbol}` === tikerRoot);
          if (findPair?.length > 0) {
            // this.getIsBotRunning(findPair[0]._id)
          }
        });
      },
      error: (err: any) => { }
    })
  }
  getIsBotRunning(pairId: any) {
    this.service.getActiveBotByPair({ pairId }).subscribe({
      next: (v: any) => {
        if (v?.result?.status === 'running') {
          this.thisPairBot = v?.result
          this.selectBot(v?.result)
        }
      },
      error: (err: any) => {
        if ([400, 404].includes(err.status)) {
        } else if (err.status === 500) {
          this.toastr.error(err.error.message);
        }
      },
      complete: () => { },
    });

  }
  getSinglePair() {
    this.botFacade.tradePair$.subscribe({

      next: (pair: any) => {
        if (!isEmpty(pair)) {
          this.isPosition = false
          this.pairData = pair
        }

      },
      error: (err: any) => { }
    })
  }
  getActiveBot() {

    let reqData = {
      status: ["running", "paused"],
      pairId: `${this.pairData?._id}`,
      filter: this.filter,
    };
    this.service.getBotHistory(reqData).subscribe({
      next: (v: any) => {
        let result = v.result;
        let count = v.count
        for (let [rIndex, history] of result.entries()) {
          result[rIndex].currentvalue = toFixedDown(history?.profit, 4);
          result[rIndex].currentvalue = toFixedDown(parseFloat(history?.profit ?? 0), 2);
          result[rIndex].pl = toFixedDown(parseFloat(history?.profitPerc ?? 0), 2);
          result[rIndex].pnlval = toFixedDown(parseFloat(history?.profit ?? 0) ?? 0, 2);
          result[rIndex].investment = toFixed(parseFloat(history?.investment ?? 0), 4);
          result[rIndex].closeDate = dateHourswithTime(history?.stopedAt);
          result[rIndex].txnDate = dateHoursClose(history?.createdAt, new Date());
          result[rIndex].creAt = dateHoursClose(history?.createdAt, history?.stopedAt);
          result[rIndex].secondCurrency = history.secondCurrency;
          result[rIndex].index = rIndex;
          result[rIndex].feeUsdt = parseFloat(history?.feeUsdt ?? 0);
          this.isPosition = true
        }
        let totalPages = Math.ceil(v?.count / this.filter.limit)
        this.filter.totalPages = totalPages
        this.getDisplayedPages = getDisplayedPages(this.filter.page, totalPages, 5)
        this.activeBotData = result;
        this.activeBotCount = count

        this.getPositionHistory("open")
        this.botSocket.on('marketPrice', this.marketPriceWs.bind(this))
      },
      error: (err: any) => {
        if ([400, 404].includes(err.status)) {
        } else if (err.status === 500) {
          this.toastr.error(err.error.message);
        }
      },
      complete: () => { },
    });
  }
  getBotHistory() {
    let reqData = {
      status: ["stopped", "paused"],
      pairId: `${this.pairData?._id}`,
      filter: this.filter,
    };
    this.service.getBotHistory(reqData).subscribe({
      next: (v: any) => {
        let result = v?.result
        let sumProfit = 0,
          totcurVal = 0,
          sumProPer = 0,
          totinv = 0;

        for (let [rIndex, history] of result.entries()) {
          result[rIndex].currentvalue = toFixedDown(history?.profit, 4);
          result[rIndex].currentvalue = toFixedDown(parseFloat(history?.profit ?? 0), 2);
          result[rIndex].pl = toFixedDown(parseFloat(history?.profitPerc ?? 0), 2);
          result[rIndex].pnlval = toFixedDown(parseFloat(history?.profit ?? 0) ?? 0, 2);
          result[rIndex].investment = toFixed(parseFloat(history?.investment ?? 0), 4);
          result[rIndex].closeDate = dateHourswithTime(history?.stopedAt);
          result[rIndex].txnDate = dateHourswithTime(history?.createdAt);
          result[rIndex].creAt = dateHoursClose(history?.createdAt, history?.stopedAt);
          result[rIndex].secondCurrency = history.secondCurrency;
          result[rIndex].index = rIndex;
          result[rIndex].feeUsdt = parseFloat(history?.feeUsdt ?? 0);
          this.isPosition = true
        }
        let totalPages = Math.ceil(v?.count / this.filter.limit)
        this.filter.totalPages = totalPages
        this.getDisplayedPages = getDisplayedPages(this.filter.page, totalPages, 5)
        this.botHistory = result;

        this.sumProfitHis = {
          sumpnl: toFixed(sumProPer, 2),
          sumpnlval: toFixed(sumProfit, 2),
          curVal: toFixed(totcurVal, 2),
          inv: toFixed(totinv, 2),
          pnlVal: toFixed(
            (sumProfit / totinv) *
            100,
            2
          )
        };
      },
      error: (err: any) => {

      },
      complete: () => { },
    });
  }
  getBotProfit() {
    this.service.getBotProfit().subscribe({
      next: (v: any) => {
        this.botProfit = v.result;
      },
      error: (err: any) => {
        if ([400, 404].includes(err.status)) {
        } else if (err.status === 500) {
          this.toastr.error(err.error.message);
        }
      },
      complete: () => { },
    });
  }
  getOrderHistory() {
    try {
      let reqData: any = {}
      if (this.openModelBotDetails) reqData = { filter: this.orderFilter, botId: this?.openModelBotDetails?._id }
      this.service.getOrderHistory(reqData).subscribe({
        next: (v: any) => {
          this.orderFilter.totalPages = Math.ceil(v?.count / this.orderFilter.limit)
          this.getDisplayedOrderPages = getDisplayedPages(this.orderFilter.page, this.orderFilter.totalPages, 5)
          let result = v?.result
          this.orderList = result
        },
        error: (err: any) => {
          console.log(err, '-------76')
        },
        complete: () => { },
      });
    } catch (err) {
      console.log(err, "---81");
    }
  };
  getOpenOrders() {
    try {
      let reqData: any = {}
      if (this.openModelBotDetails) reqData = { filter: this.orderFilter, botId: this?.openModelBotDetails?._id }
      this.service.getOpenOrders(reqData).subscribe({
        next: (v: any) => {
          this.orderFilter.totalPages = Math.ceil(v?.count / this.orderFilter.limit)
          this.getDisplayedOrderPages = getDisplayedPages(this.orderFilter.page, this.orderFilter.totalPages, 5)
          let result = v?.result
          this.openOrderList = result
        },
        error: (err: any) => {
          console.log(err, '-------76')
        },
        complete: () => { },
      });
    } catch (err) {
      console.log(err, "---81");
    }
  };

  getPositionHistory(ordertype = "all") {
    try {
      this.service.getPositionHistory({ botId: this.openModelBotDetails?._id, filter: this.orderFilter, ordertype }).subscribe({
        next: (v: any) => {
          this.orderFilter.totalPages = Math.ceil(v?.count / this.orderFilter.limit)
          this.getDisplayedOrderPages = getDisplayedPages(this.orderFilter.page, this.orderFilter.totalPages, 5)
          let result = v?.result
          this.botPositionHistory = result
        },
        error: (err: any) => {
          console.log(err, '-------76')
        },
        complete: () => { },
      });
    } catch (err) {
      console.log(err, "---81");
    }
  };

  cancel(orderType: any, closeType: any, doc: any) {
    this.cancelLoader = true;
    this.toastr.success("Please wait for a while")
    // try {
    let reqData = {
      exchange: this.pairData.botstatus,
      botId: doc?._id ? doc?._id : "",
      positionId: "",
      // stopMarket: true
      stopMarket: closeType == "keep",
      closeType
    };
    if (orderType == "position") {
      reqData.positionId = doc?._id ? doc?._id : ""
      reqData.botId = ""
    }
    this.service.closeBot(reqData)
      .subscribe({
        next: (v: any) => {
          this.cancelLoader = false
          if (v.status) {
            this.toastr.success(v.message)
          } else {
            this.toastr.success(v.message)
          }
        },
        error: (err: any) => {
          this.cancelLoader = false;
          if (err.error.message) {
            this.toastr.error(err.error.message)
          }
        }
      })
  }
  pauseBot(closeType: any,) {
    this.cancelLoader = true;
    this.toastr.success("Please wait for a while")
    // try {
    let reqData = {
      exchange: this.pairData.botstatus,
      positionId: "",
      // stopMarket: true
      stopMarket: closeType == "keep",
      closeType
    };
    this.service.pauseBot(reqData)
      .subscribe({
        next: (v: any) => {
          this.cancelLoader = false
          if (v.status) {
            this.toastr.success(v.message)
          } else {
            this.toastr.success(v.message)
          }
        },
        error: (err: any) => {
          this.cancelLoader = false;
          if (err.error.message) {
            this.toastr.error(err.error.message)
          }
        }
      })
  }
  cancelAndWait(orderId: any) {
    this.cancelLoader = true;
    this.toastr.success("Please wait for a while")
    // try {
    let reqData = {
      orderId
    };
    this.service.cancelAndWait(reqData)
      .subscribe({
        next: (v: any) => {
          this.cancelLoader = false
          if (v.status) {
            this.toastr.success(v.message)
          } else {
            this.toastr.success(v.message)
          }
        },
        error: (err: any) => {
          this.cancelLoader = false;
          if (err.error.message) {
            this.toastr.error(err.error.message)
          }
        }
      })
  }

  marketPriceWs(result: any) {
    if (this.botPositionHistory?.length > 0) {

      for (let item of this.botPositionHistory) {
        if ((isEmpty(item?.sellOrderId) || item?.sellOrderId?.status === 'pending' || item?.sellOrderId?.status === 'cancelWait') && item.symbol === result.symbol) {
          const markPrice = parseFloat(result?.data?.bestBid ?? result?.data?.markPrice);

          if (isEmpty(item?.sellOrderId)) {
            item.sellOrderId = {};
            item.sellOrderId.status = "cancelWait";
          }

          // Note: In your code, 'entryPrice' is actually the Total Cost (Price * Quantity)
          const entryPrice = (item?.openPrice * item?.quantity);
          let exitPrice = item?.quantity * markPrice;
          const totalFee = item?.openFee * 2;

          const orderEstProfit = (exitPrice - entryPrice) - totalFee;

          // ✅ Calculate Profit Percentage
          // Formula: (Net Profit / Total Invested Amount) * 100
          let profitPercent = 0;
          if (entryPrice > 0) {
            profitPercent = (orderEstProfit / entryPrice) * 100;
          }

          // ✅ Update the local object
          item.sellOrderId.markPrice = markPrice;
          item.esProfit = orderEstProfit.toFixed(2);
          item.profitPercent = parseFloat(profitPercent.toFixed(2)); // Storing as a number with 2 decimal precision
        }
      }

      // optional: reassign to trigger UI updates if reactive (e.g., Angular)
      this.botPositionHistory = [...this.botPositionHistory]
    }
  }

  // table api and filter datas
  previousPage(type: any) {
    if (type == "bot") {
      let page = this.filter.page - 1
      this.filter = { ...this.filter, page: page, skip: page * this.filter.limit }
      this.callTableApi(this.selectedTab)
    } else if (type == "order") {
      let page = this.orderFilter.page - 1
      this.orderFilter = { ...this.orderFilter, page: page, skip: page * this.orderFilter.limit }
      this.callTableApi(this.selectedOrderTab)
    }
  }
  nextPage(type: any) {
    if (type == "bot") {
      let page = this.filter.page + 1
      this.filter = { ...this.filter, page: page, skip: page * this.filter.limit }
      this.callTableApi(this.selectedTab)
    } else if (type == "order") {
      let page = this.orderFilter.page + 1
      this.orderFilter = { ...this.orderFilter, page: page, skip: page * this.orderFilter.limit }
      this.callTableApi(this.selectedOrderTab)
    }
  }
  goToSelectedPage(item: any, type: any) {
    if (type == "bot") {
      this.filter.page = item
      this.filter = { ...this.filter, page: item, skip: (item - 1) * this.filter.limit }
      this.callTableApi(this.selectedTab)
    } else if (type == "order") {
      this.orderFilter.page = item
      this.orderFilter = { ...this.orderFilter, page: item, skip: (item - 1) * this.orderFilter.limit }
      this.callTableApi(this.selectedOrderTab)
    }
  }
  selectTab(tab: any, type: any) {
    if (type == 'bot') {
      this.selectedTab = tab
      this.filter = { ...this.filter, totalPages: 0, page: 1, skip: 0 }
      if (!isEmpty(this.thisPairBot))
        this.selectBot(this.thisPairBot)
    } else if (type == 'order') {
      this.selectedOrderTab = tab
      this.orderFilter = { ...this.orderFilter, totalPages: 0, page: 1, skip: 0 }
    } else if (type == 'openPosition') {
      this.selectedOrderTab = tab
      this.orderFilter = { ...this.orderFilter, totalPages: 0, page: 1, skip: 0 }
    }
    this.callTableApi(tab)
  }
  onModelOpen(reqData: any) {
    this.selectedOrderTab = "positionHistory"
    this.openModelBotDetails = reqData
    this.orderFilter = { ...this.orderFilter, totalPages: 0, page: 1, skip: 0 }
    this.getPositionHistory("all")
  }
  onModelClose() {
    this.openModelBotDetails = null
    this.orderFilter = { ...this.orderFilter, totalPages: 0, page: 1, skip: 0 }
  }
  callTableApi(tabToLoad: any) {
    switch (tabToLoad) {
      case 'activeBot':
        this.getActiveBot()
        break;
      case 'stopedBot':
        this.getBotHistory()
        break;
      case 'positionHistory':
        this.getPositionHistory("all")
        break;
      case 'openPosition':
        this.getPositionHistory("open")
        break;
      case 'closedOrder':
        this.getOrderHistory()
        break;
      case 'openOrder':
        this.getOpenOrders()
        break;
    }
  }

  loadChart(symbol: any) {
    const originalPair = this.pairs.find((v: any) => v.symbol === symbol);
    if (!originalPair) {
      this.toastr.error("Invalid pair");
      return false;
    }

    // FIX 1: Create a shallow copy to avoid mutating the original object in 'this.pairs'.
    const fullPair = { ...originalPair };

    // FIX 2: Your logic is still hardcoded to "USDT" and will fail for other pairs.
    // (Also removed unnecessary '?' optional chaining)
    fullPair.firstCurrencySymbol = fullPair.symbol.replace("USDT", "");
    fullPair.secondCurrencySymbol = "USDT";

    this.service.setTradePair(fullPair); // Pass the new, copied object

    // FIX 3: Return true on success
    return true;
  }



  // bot create
  handleTradeChange(e: any): void {
    e.preventDefault()
    let { name, value } = e.target
    if (
      ["investment", "upperPrice", "lowerPrice", "grids", "gridStepPercent", "gridStepValue", "takeprofitRatio",
        "takeprofitCallback", "stopLoss", "buyPercentage", "buyCount", "sellPercentage", "sellCount"].includes(name)
    ) {
      //number 
      const isValidFloat = /^(\d+)?(\.\d{0,10})?$/.test(value) || value === '' || value === '.';
      if (!isValidFloat) return
    }

    if (['buyPercentage', "sellPercentage"].includes(name)) {
      if (name == 'buyPercentage') {
        let allowVal = 100 - parseFloat(this.formValue.sellPercentage)
        if (value > allowVal) {
          e.target.value = allowVal;
          value = allowVal;
        }
      }
      if (name == 'sellPercentage') {
        let allowVal = 100 - parseFloat(this.formValue.buyPercentage)
        if (value > allowVal) {
          e.target.value = allowVal;
          value = allowVal;
        }
      }
    }
    //number 
    // cur decimals based on binance
    if (["upperPrice", "lowerPrice", "gridStepValue", "investment"].includes(name)) value = toFixedDown(value, this.pairData?.secondFloatDigit)
    // if (["investment"].includes(name)) value = toFixedDown(value, this.pairData?.secondFloatDigit)

    this.formValue = { ...this.formValue, ...{ [name]: value } };
    if (value) {
      this.serverErrors = { ...this.serverErrors, ...{ [name]: "" } };
      this.loader = false;
    }
  }

  filterFloatKeydown(event: KeyboardEvent, fieldName: string): void {
    const allowedKeys = [
      'Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete', 'Home', 'End'
    ];
    // allow navigation, shortcuts, etc.
    if (
      allowedKeys.includes(event.key) ||
      event.ctrlKey ||
      event.metaKey
    ) {
      return;
    }

    // only digits or dot
    if (!/^[0-9.]$/.test(event.key)) {
      event.preventDefault();
      return;
    }

    // determine how many decimals we can have
    let decimalLimit = 6;
    if (["upperPrice", "lowerPrice", "investment", "gridStepValue"].includes(fieldName)) {
      decimalLimit = parseInt(this.pairData.secondFloatDigit) ?? 6;
    } else if (fieldName === "grids") {
      decimalLimit = 0;
    }

    const input = event.target as HTMLInputElement;
    const { selectionStart: start, selectionEnd: end, value } = input;
    if (start === null || end === null) {
      // fall back to default
      return;
    }

    // build what the new value *would* be
    const before = value.slice(0, start);
    const after = value.slice(end);
    const newValue = before + event.key + after;

    // regex: any number of digits, optionally a dot followed by up to decimalLimit digits
    const re = new RegExp(`^\\d*(?:\\.\\d{0,${decimalLimit}})?$`);

    if (!re.test(newValue)) {
      event.preventDefault();
      return;
    }
  }

  submitForm(): any {
    try {
      this.serverErrors = {}; // Clear previous errors
      const errors: any = {};

      if (this.formValue.isManual)
        this.formValue.profitPercentage = 0.1
      // Parse the new split order inputs
      const totalBots = parseFloat(this.formValue?.totalBots) || 0;
      const profitPercentage = parseFloat(this.formValue?.profitPercentage) || 0;
      const order1 = parseFloat(this.formValue?.firstOrderInvest) || 0;
      const order2 = parseFloat(this.formValue?.secondOrderInvest) || 0;
      const order3 = parseFloat(this.formValue?.thirdOrderInvest) || 0;
      if (!totalBots) errors.totalBots = "Required";
      if (!profitPercentage) errors.profitPercentage = "Required";
      if (profitPercentage <= 0) errors.profitPercentage = "Required";
      if (!order1) errors.firstOrderInvest = "Required";
      if (!order2) errors.secondOrderInvest = "Required";
      if (!order3) errors.thirdOrderInvest = "Required";
      // 🚨 5. Stop if any errors found
      if (Object.keys(errors).length > 0) {
        this.serverErrors = errors;
        return;
      }

      // 1. Parse all inputs to numbers (default to 0 if empty)
      const investment = (order1 + order2 + order3) * totalBots;

      // 2. Basic Required Validations
      if (totalBots <= 0) errors.totalBots = "Required";
      if (investment <= 0) errors.investment = "Required";

      // 🧩 3. NEW VALIDATION: Check if 1st + 2nd + 3rd = (Investment / TotalBots)
      if (investment > 0 && totalBots > 0) {
        const targetPerBot = investment / totalBots;
        const sumOfOrders = order1 + order2 + order3;

        // Use Math.abs for floating point comparison (allow 0.05 tolerance)
        if (Math.abs(targetPerBot - sumOfOrders) > 0.05) {
          const msg = `Sum of orders (${sumOfOrders.toFixed(2)}) must match Investment (${investment.toFixed(2)})`;

          // Mark all fields as invalid, but put the message on the last one
          errors.firstOrderInvest = " ";
          errors.secondOrderInvest = " ";
          errors.thirdOrderInvest = " ";
          errors.investment = msg;
        }
      }

      // 4. Minimum order validations (Existing Logic)
      const fullPair = this.pairs.find((v: any) => v._id === this.pairData._id);
      if (!fullPair) {
        this.toastr.error("Invalid pair");
        return false;
      }

      // Check Global Minimum Investment
      if (fullPair?.minInvestment && investment < fullPair.minInvestment) {
        errors.investment = `Minimum investment is ${fullPair?.minInvestment} ${fullPair.secondCurrencySymbol}`;
      }

      // 🚨 5. Stop if any errors found
      if (Object.keys(errors).length > 0) {
        this.serverErrors = errors;
        return;
      }

      // --- Proceed to API Call ---
      this.isSubmitting = true;
      let formValue = this.formValue;
      let pairName = `${this.pairData.firstCurrencySymbol}${this.pairData.secondCurrencySymbol}`;

      let genDet = {
        pairName: `${this.pairData.firstCurrencySymbol}-${this.pairData.secondCurrencySymbol}`,
        investment: investment,
        firstCurrencySymbol: this.pairData.firstCurrencySymbol,
        secondCurrencySymbol: this.pairData.secondCurrencySymbol,
        totalBots: this.formValue.totalBots,

        // ✅ ADDED: Send the split values to the backend
        firstOrderInvest: order1,
        secondOrderInvest: order2,
        thirdOrderInvest: order3,
        profitPercentage: profitPercentage,
        isManual: this.formValue.isManual
      };

      let reqData = {
        pairName: pairName,
        pairId: this?.pairData?._id,
        exchange: "binance",
        BotType: "VMAP",
        RunStatus: false,
        tradesetting: genDet,
        orderType: "Limit",
        validate: false
      };

      this.toastr.success("Please wait for a while");

      this.service.orderPlace(reqData).subscribe({
        next: (v: any) => {
          this.toastr.success(v.message);
          reqData.validate = false;
          this.isSubmitting = false;
          this.formValue = {};
          this.serverErrors = {};
          document.getElementById('cancelBtn')?.click();
        },
        error: (err: any) => {
          this.isSubmitting = false;
          reqData.validate = false;

          if ([400, 404].includes(err.status)) {
            if (err?.error?.message) this.toastr.error(err?.error?.message);

            const validationErrors = err.error.errors;
            if (!isEmpty(validationErrors)) {
              this.serverErrors = validationErrors || {};
              this.toastr.error(err.error.message);
              if (err?.error?.order) {
                this.toastr.error(err.error.order);
              }
            }
          } else if (err.status === 500) {
            this.toastr.error(err.error.message);
          }
        },
        complete: () => { },
      });
      return false;
    } catch (err) {
      console.log(err, "submitForm Error");
      this.isSubmitting = false;
      return false;
    }
  }


}
